import { documentCategoriesApi, documentTypesApi } from 'app/services/api';

import { SystemCategoryIdList } from 'constants/documentCategories';
import { catchAsyncActionError } from 'utils/action';
import {
  normalizeDocumentCategoriesWithSystemCategories,
  normalizeDocumentCategory,
} from 'utils/documentCategories';

import { getDocumentCategories, selectExcludedDocumentTypes } from 'store/system/selectors';

import { getDocumentTypesAction } from './documentTypes.actions';

export const GET_DOCUMENT_CATEGORIES = 'GET_DOCUMENT_CATEGORIES';
export const REORDER_DOCUMENT_TYPE_IN_CATEGORY = 'REORDER_DOCUMENT_TYPE_IN_CATEGORY';
const DELETE_DOCUMENT_CATEGORY = 'DELETE_DOCUMENT_CATEGORY';
const ADD_NEW_DOCUMENT_CATEGORY = 'ADD_NEW_DOCUMENT_CATEGORY';
const EDIT_DOCUMENT_CATEGORY = 'EDIT_DOCUMENT_CATEGORY';
export const MOVE_DOCUMENT_TYPE_TO_ANOTHER_CATEGORY = 'MOVE_DOCUMENT_TYPE_TO_ANOTHER_CATEGORY';

export const getDocumentCategoriesAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const state = getState();
    const excludedDocumentTypes = selectExcludedDocumentTypes(state);

    const [{ data: inactiveDocumentTypes }, { data: documentCategories }] = await Promise.all([
      documentTypesApi.getDocumentTypes({ inactiveCategory: true }),
      documentCategoriesApi.getDocumentCategories({ include: 'types' }),
    ]);

    return dispatch({
      type: GET_DOCUMENT_CATEGORIES,
      payload: normalizeDocumentCategoriesWithSystemCategories({
        documentCategories,
        excludedDocumentTypesIds: Object.keys(excludedDocumentTypes),
        inactiveDocumentTypeIds: inactiveDocumentTypes.map(({ id }) => id),
      }),
    });
  },
);

export const reorderDocumentTypeInCategoryAction = data => ({
  type: REORDER_DOCUMENT_TYPE_IN_CATEGORY,
  payload: data,
});

export const reorderDocumentCategoryAction = catchAsyncActionError(
  afterReorderDocumentCategories => async dispatch => {
    const categoryIds = afterReorderDocumentCategories.reduce((acc, { documentCategoryId }) => {
      if (SystemCategoryIdList.includes(documentCategoryId)) {
        return acc;
      }

      acc.push(documentCategoryId);

      return acc;
    }, []);

    dispatch(reorderDocumentTypeInCategoryAction(afterReorderDocumentCategories));

    await documentCategoriesApi.reorderDocumentCategory(categoryIds);
  },
);

export const removeCategoryAction = catchAsyncActionError(
  ({ documentCategoryId, newCategoryId }) =>
    async dispatch => {
      await documentCategoriesApi.deleteDocumentCategory({ documentCategoryId, newCategoryId });

      return dispatch({ type: DELETE_DOCUMENT_CATEGORY });
    },
);

export const addNewCategoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentCategoriesApi.createDocumentCategory(params);

  return dispatch({
    type: ADD_NEW_DOCUMENT_CATEGORY,
    payload: normalizeDocumentCategory(data),
  });
});

export const renameCategoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentCategoriesApi.editDocumentCategory(params);

  return dispatch({
    type: EDIT_DOCUMENT_CATEGORY,
    payload: normalizeDocumentCategory(data),
  });
});

export const getDocumentTypesWithDocumentCategoriesAction = () => dispatch => {
  return dispatch(getDocumentTypesAction())
    .then(() => dispatch(getDocumentCategoriesAction()))
    .catch(Error);
};

export const moveDocumentTypeToAnotherCategoryAction =
  ({ documentTypeId, fromCategoryId, toCategoryId }) =>
  (dispatch, getState) => {
    const documentCategories = getDocumentCategories(getState());
    const payload = documentCategories.map(category => {
      if (category.documentCategoryId === fromCategoryId) {
        return {
          ...category,
          documentTypeIds: category.documentTypeIds.filter(item => item !== documentTypeId),
        };
      }

      if (category.documentCategoryId === toCategoryId) {
        return {
          ...category,
          documentTypeIds: [documentTypeId, ...category.documentTypeIds],
        };
      }

      return category;
    });

    dispatch({
      type: MOVE_DOCUMENT_TYPE_TO_ANOTHER_CATEGORY,
      payload,
    });
  };
